export const AppConstants = {
  // Currently primarily use to define constants for local storage keys
  READ_ONLY_LAYOUT: 'read-only-layout',
  LOCAL_STORAGE_LEFT_DRAWER: 'local-config.leftDrawerWidth',
  LOCAL_STORAGE_HIDE_EDIT_PROMPT: 'local-config.hideEditPrompt',
  RECENT_SEARCHES_IDENTIFIER: 'search.recent-searches',
  BANNERS_TO_HIDE: 'local-config.hidden-banners',
  LOCAL_STORAGE_READ_ALOUD: 'read-aloud-store',
  LOCAL_STORAGE_FEATURE_GALLERY_SHOW_MODAL: 'feature-gallery.show-modal'
};
